import { render, staticRenderFns } from "./CoordinatorTeams.vue?vue&type=template&id=826bc214&scoped=true&"
import script from "./CoordinatorTeams.vue?vue&type=script&lang=js&"
export * from "./CoordinatorTeams.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorTeams.vue?vue&type=style&index=0&id=826bc214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826bc214",
  null
  
)

export default component.exports